var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrevious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.438 7.019L7.187.449a.694.694 0 01.974 0l.407.401c.269.267.269.697 0 .963L2.707 7.5l5.855 5.687c.27.266.27.696 0 .963l-.407.402a.694.694 0 01-.974 0L.432 7.982a.68.68 0 01.006-.963z",
    fill: "#4E59F5"
  })));
}

export default __webpack_public_path__ + "./fonts/previous.0b1f7e89db9637f6248d2481d5fe8b42.svg";
export { SvgPrevious as ReactComponent };